import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { forwardRef } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import merge from 'deepmerge';
import ButtonBase from './Base/ButtonBase.js';
import btnChevron from '../../styles/btnChevron.js';
import GlyphRight from '../../svg/GlyphRight.js';
import { dlsGray03 } from '../../styles/colorsDls/dlsGray03.js';
import { dlsGray05 } from '../../styles/colorsDls/dlsGray05.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ButtonChevron = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      theme = props.theme;
      props.loading;
      var otherProps = _objectWithoutProperties(props, ["children", "theme", "loading"]);

  var styleTypeObject = merge.all([btnChevron.btnChevron, {
    '&::after': {}
  }, theme]);

  var chevronStyleObject = _objectSpread({
    marginRight: '0.375rem',
    marginTop: '-0.5rem',
    position: 'absolute',
    right: '0',
    top: '50%'
  }, otherProps.disabled ? dlsGray03 : dlsGray05);

  return jsx(ButtonBase, _extends({}, otherProps, {
    theme: styleTypeObject,
    ref: ref,
    styled: true
  }), children, jsx(GlyphRight, {
    size: "lg",
    theme: chevronStyleObject
  }));
});
ButtonChevron.displayName = 'ButtonChevron';
ButtonChevron.defaultProps = {
  children: '',
  type: 'button',
  theme: {}
};

export default ButtonChevron;
